<template>
    <div class="clearfix">
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormEdit
                class="padding-top-15"
                ref="form"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            ></compFormEdit
        ></compWrapper>
        <compWrapper
            v-if="querytype == 'query'"
            theme="gray"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <div class="margin-15 pull-right" v-if="querytype != 'query'">
            <Button class="margin-right-15" type="primary" @click="submit">{{
                $t("global.common.save", { defaultValue: "保存" })
            }}</Button>
            <Button type="default" @click="$emit('on-close')">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpSaveLogiticMeasure,
    HttpLogiticServiceOne,
    HttpLogisticMeasureLog,
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            formData: {},
            carrierGroupList: [],
            carrierServiceList: [],
            logList: [],
            loading: false,
        };
    },
    created() {
        if (this.querytype == "query") {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getCarrierAllList"]),
        getBase() {
            return [
                {
                    label: this.$t("fbb.expresspackage.service_code", {
                        defaultValue: "承运商",
                    }),
                    key: "carrierId",
                    tag: "vSelect",
                    options: this.getCarrierAllList.map((item) => {
                        return {
                            label: item.label,
                            value: item.attach.id,
                        };
                    }),
                    query: this.querytype == "query",
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                    on: {
                        "on-change": (val) => {
                            this.getCarrierServiceId(val);
                        },
                    },
                },
                {
                    label: this.$t("erp.b2c.hippingMethodCode", {
                        defaultValue: "物流服务",
                    }),
                    query: this.querytype == "query",
                    key: "carrierServiceId",
                    tag: "vSelect",
                    options: this.carrierServiceList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            await HttpLogisticMeasureLog({
                id: this.activeid,
            }).then(
                (res) => {
                    console.log(res);
                    this.formData.carrierId = res.data.carrierId;
                    this.getCarrierServiceId(this.formData.carrierId);
                    this.formData.carrierServiceId = res.data.carrierServiceId;
                    this.logList = res.data.orderLogList || [];
                },
                (err) => {
                    this.$VMessage.error(err);
                }
            );
            this.loading = false;
        },
        async getCarrierServiceId(carrierId) {
            HttpLogiticServiceOne({ carrierId: carrierId }).then((res) => {
                if (res.data) {
                    this.carrierServiceList = res.data.map((item) => {
                        return {
                            label: `${item.code}(${item.carrierServiceName})`,
                            value: item.id,
                        };
                    });
                } else {
                    this.carrierServiceList = [];
                }
            });
        },
        // async getDetail() {
        //     this.loading = true;
        //     await HttpGetCarrierServiceDetail({
        //         id: this.activeid,
        //     }).then(
        //         (res) => {
        //             this.formData = res.data;
        //         },
        //         (err) => {
        //             this.$VMessage.error(err.message);
        //         }
        //     );
        //     this.loading = false;
        // },
        async submit() {
            let flag = await this.$refs.form.validate();
            if (!flag) return;
            this.loading = true;
            await HttpSaveLogiticMeasure({
                ...this.formData,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style>
</style>